import { type IParamsOrganizationQuietHours } from 'entities/Organization/api/types'
import { QuietHours } from '../model'
import { isInQuietHoursTimeframe } from './quietHours'
import { CallDuringQuietHoursModal } from '../ui/CallDuringQuietHoursModal'

export type IShowCallDuringQuietHoursModalIfNeededParams = {
  timezone: string
  contactName: string
  organizationQuietHoursSettings: IParamsOrganizationQuietHours | null | undefined
  isQuietHoursFeatureEnabled: boolean
  onConfirm: () => void | Promise<void>
}

export const showCallDuringQuietHoursModalIfNeeded = (
  params: IShowCallDuringQuietHoursModalIfNeededParams
): boolean => {
  const {
    timezone,
    contactName,
    organizationQuietHoursSettings,
    isQuietHoursFeatureEnabled,
    onConfirm,
  } = params

  const quietHours = new QuietHours(organizationQuietHoursSettings)
  const isShowQuietHoursModal =
    isQuietHoursFeatureEnabled &&
    quietHours.isQuietHoursEnabled &&
    isInQuietHoursTimeframe(
      timezone,
      quietHours.quietHoursAllowedTimeFrom,
      quietHours.quietHoursAllowedTimeTo
    )

  if (!isShowQuietHoursModal) return false

  CallDuringQuietHoursModal({
    timezone,
    contactName,
    quietHoursAllowedTimeFrom: quietHours.quietHoursAllowedTimeFrom,
    quietHoursAllowedTimeTo: quietHours.quietHoursAllowedTimeTo,
    isQuietHoursBlockOnWeekend: quietHours.isQuietHoursBlockOnWeekend,
    onConfirm,
  })

  return true
}
